import React from 'react';
import { sortBasedOnList } from '../utils';

export type Table3bData = { [key: string]: ITable3bRow };

interface ITable3bRow {
  crashesTotal: number;
  crashesFatal: number;
  crashesInjuryA: number;
  crashesInjuryB: number;
  crashesInjuryC: number;
  crashesPDO: number;
  personsFatal: number;
  personsInjuryA: number;
  personsInjuryB: number;
  personsInjuryC: number;
}

export interface ITable3bProps {
  data: Table3bData;
}

const sortOrder = [
  "State",
  "County",
  "City",
];

export default class Table3b extends React.Component<ITable3bProps> {
  constructor(props: ITable3bProps) {
    super(props);
  }

  render() {
    return (
      this.props.data ?
        <table className="ss-table summaryTable1">
          <colgroup>
            <col style={{ width: '367px' }} />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={3} className="border-right-bold">
                <div className="ss-table-header">
                  <span className="header-number">3b</span>
                  <span className="header-text">OWNERSHIP</span>
                </div>
              </th>
              <th colSpan={6} className="border-right-bold">CRASHES</th>
              <th colSpan={4} className="border-right-bold">PERSONS</th>
            </tr>
            <tr>
              <th rowSpan={2}>TOTAL</th>
              <th rowSpan={2}>FATAL</th>
              <th colSpan={3}>INJURY</th>
              <th rowSpan={2} className="border-right-bold">PDO **</th>
              <th rowSpan={2}>KILLED</th>
              <th colSpan={3}>INJURY</th>
            </tr>
            <tr>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
            </tr>
          </thead>
          <tbody>
            {sortBasedOnList(this.props.data, sortOrder).map((key) =>
              <tr key={key}>
                <td className="border-right-bold">{key}</td>
                <td className="numberTotals">{this.props.data[key].crashesTotal}</td>
                <td className="numberTotals">{this.props.data[key].crashesFatal}</td>
                <td className="numberTotals">{this.props.data[key].crashesInjuryA}</td>
                <td className="numberTotals">{this.props.data[key].crashesInjuryB}</td>
                <td className="numberTotals">{this.props.data[key].crashesInjuryC}</td>
                <td className="numberTotals border-right-bold">{this.props.data[key].crashesPDO}</td>
                <td className="numberTotals">{this.props.data[key].personsFatal}</td>
                <td className="numberTotals">{this.props.data[key].personsInjuryA}</td>
                <td className="numberTotals">{this.props.data[key].personsInjuryB}</td>
                <td className="numberTotals">{this.props.data[key].personsInjuryC}</td>
              </tr>
            )}
          </tbody>
        </table>
        : <p>Loading...</p>
    )
  }
};
